import { AdvertiserDashboard } from '../components/Advertiser';

export function AdvertiserPage() {
  return <AdvertiserDashboard />;
}
